import { DownloadButtonResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';
import adaptFilterRequest from './adaptFilterRequest';
import BaseAdapter from './baseAdapter';

export default class PostTemporaryCsv extends BaseAdapter<DownloadButtonResponse> implements AdapterInterface {
  rawResponse: DownloadButtonResponse;

  async adaptResponse(request: { selectedFilters: SelectedFilters }): Promise<string> {
    const formattedRequest = adaptFilterRequest(request.selectedFilters);
    await this.fetchApiResponse('/api/temporary-csv', HTTPMethod.Post, formattedRequest);
    return this.rawResponse.signed_url;
  }
}
